import React, { useState, useEffect, useRef } from "react";
import {
    API_GET_CUSTOMIZATION,
    API_CUSTOMIZE_ADD_TO_CART,
} from "../modals/Constants";
import { getStorage, setStorage } from "../modals/Storage";
import general from "../css/General.module.css";
import screen from "../css/Screen.module.css";
import AlertDialog from "../dialogs/AlertDialog/dialog";
import LoadingDialog from "../dialogs/LoadingDialog/dialog";
import HeaderView from "../other-components/HeaderView/view";
import ImageLoader from "../other-components/ImageLoader";
import Snackbar from "@mui/material/Snackbar";
import Button from "../UI/Button/ui";

function Customization() {
    const [snackbar, setSnackbar] = useState(false);

    const [loading, setLoading] = useState(false);
    const [loadingTitle, setLoadingTitle] = useState("");

    const [values, setConstants] = useState({
        instruction: "",
        size: 0,
        quantity: 1,
        subTotal: 0,
        sizeList: [],
    });

    const [dialog, setAlertDialog] = useState(false);
    const [dialogMessage, setAlertDialogMessage] = useState("");

    // store {file, preview} objects
    const [uploadedImages, setUploadedImages] = useState([]);
    const [isDragging, setIsDragging] = useState(false);

    // new state for delete confirmation
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [selectedImageIndex, setSelectedImageIndex] = useState(null);

    const fileInputRef = useRef(null);

    const handleFileClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const processFiles = (files) => {
        const validFiles = files.filter((file) =>
            ["image/png", "image/jpeg", "image/jpg"].includes(file.type)
        );

        const fileObjs = validFiles.map((file) => ({
            file,
            preview: URL.createObjectURL(file),
        }));

        const newImages = [...uploadedImages, ...fileObjs];
        setUploadedImages(newImages);

        // update quantity according to image uploaded
        updateQuantity(newImages.length);
    };

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        processFiles(files);
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => {
        setIsDragging(false);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        setIsDragging(false);

        const files = Array.from(event.dataTransfer.files);
        processFiles(files);
    };

    const handleImageClick = (index) => {
        setSelectedImageIndex(index);
        setDeleteDialog(true);
    };

    const confirmDeleteImage = () => {
        if (selectedImageIndex !== null) {
            const newImages = uploadedImages.filter((_, i) => i !== selectedImageIndex);
            setUploadedImages(newImages);

            // update quantity according to image uploaded
            updateQuantity(newImages.length);
        }
        setDeleteDialog(false);
        setSelectedImageIndex(null);
    };

    async function loadRecords() {
        const fecthApiData = async (url, formData) => {
            try {
                const res = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bearer ${getStorage("accountSecret")}`,
                    },
                    body: JSON.stringify(formData),
                });
                const data = await res.json();
                setLoading(false);

                if (data.status_code == "success") {
                    resetValues(data.data);
                    setStorage("app_cart_items", data.total_cart_records);
                }
            } catch (error) {
                setLoading(false);
            }
        };

        setLoading(true);
        const formData = {
            ACCOUNT_ID: getStorage("accountID"),
        };

        fecthApiData(API_GET_CUSTOMIZATION, formData);
    }

    const resetValues = (data) => {
        let quantity = 1;
        setUploadedImages([]);

        let subTotal = 0;
        if (data.length > 0) {
            subTotal = data[values.size]["price"] * quantity;
        }

        setConstants((prev) => ({
            ...prev,
            instruction: "",
            sizeList: data,
            quantity: quantity,
            subTotal: subTotal,
        }));
    };

    const updateSize = (index) => {
        let subTotal = values.sizeList[index]["price"] * values.quantity;
        setConstants((prev) => ({
            ...prev,
            size: index,
            subTotal: subTotal,
        }));
    };

    const updateQuantity = (quantity) => {
        console.log(quantity);

        let subTotal = values.sizeList[values.size]["price"] * quantity;
        setConstants((prev) => ({
            ...prev,
            quantity: quantity,
            subTotal: subTotal,
        }));
    };

    const setUploadProgress = (progress) => {
        setLoadingTitle("Uploading.." + progress + "%");
    };

    const uploadWithProgress = (url, formData, onProgress) => {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open("POST", url, true);
            xhr.setRequestHeader(
                "authorization",
                `Bearer ${getStorage("accountSecret")}`
            );

            // track progress
            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    const percent = Math.round(
                        (event.loaded / event.total) * 100
                    );
                    onProgress(percent);
                }
            };

            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(JSON.parse(xhr.responseText));
                } else {
                    reject(xhr.statusText);
                }
            };

            xhr.onerror = () => reject("Network error");

            xhr.send(formData);
        });
    };

    const addToBag = async () => {
        if (getStorage("accountID") === "") {
            setAlertDialogMessage(
                "Please sign in to add items to your cart."
            );
            setAlertDialog(true);
        } else if (uploadedImages.length <= 0) {
            setAlertDialogMessage(
                "Please select atleast one image to continue."
            );
            setAlertDialog(true);
        } else {
            setLoading(true);
            setUploadProgress(0);

            const formData = new FormData();
            formData.append("ACCOUNT_ID", getStorage("accountID"));
            formData.append("PRODUCT_SIZE", values.size);
            formData.append("PRODUCT_INSTRUCTION", values.instruction);
            formData.append("PRODUCT_QUANTITY", values.quantity);

            uploadedImages.forEach((img) => {
                formData.append("PRODUCT_IMAGES[]", img.file);
            });

            try {
                const data = await uploadWithProgress(
                    API_CUSTOMIZE_ADD_TO_CART,
                    formData,
                    (percent) => setUploadProgress(percent) // update state
                );

                setLoading(false);

                if (data.status_code === "success") {
                    setLoadingTitle("");
                    loadRecords();
                    setSnackbar(true);
                }
            } catch (err) {
                console.error(err);
                setLoading(false);
            }
        }
    };

    const updateInput = (value) => {
        setConstants((prev) => ({
            ...prev,
            instruction: value,
        }));
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === "clickaway") return;
        setSnackbar(false);
    };

    useEffect(() => {
        loadRecords();
    }, []);

    return (
        <div className={general.appView}>
            <LoadingDialog isOpen={loading} title={loadingTitle} />

            <Snackbar
                open={snackbar}
                autoHideDuration={2500}
                onClose={handleSnackbarClose}
                message="Product added to cart."
            />

            <AlertDialog
                isOpen={dialog}
                title={"Alert"}
                description={dialogMessage}
                onClose={() => setAlertDialog(false)}
                actions={[
                    {
                        label: "Cancel",
                        variant: "neutral",
                        onClick: () => setAlertDialog(false),
                    },
                ]}
            />

            {/* Delete Image Dialog */}
            <AlertDialog
                isOpen={deleteDialog}
                title="Remove Image"
                description="Are you sure you want to delete this image?"
                onClose={() => setDeleteDialog(false)}
                actions={[
                    {
                        label: "Yes",
                        variant: "positive",
                        onClick: confirmDeleteImage,
                    },
                    {
                        label: "No",
                        variant: "neutral",
                        onClick: () => setDeleteDialog(false),
                    },
                ]}
            />

            <div className={general.appChildView}>
                <HeaderView screen={"myorders"} />

                <div className={general.appLocationViews}>
                    <p>Customization</p>
                </div>

                <div className={general.appContentsView}>
                    <div className={[screen.cartView, general.mgB100px].join(" ")}>
                        <div className={screen.contentsView}>
                            <p className={screen.title}>Customize product</p>
                            <p>Just upload the image & place your order.</p>

                            <br />
                            <p>Available Sizes</p>
                            <div className={screen.sizesListView}>
                                {values.sizeList.map((item, index) => (
                                    <button
                                        key={index}
                                        className={[
                                            screen.sizeItem,
                                            values.size === index
                                                ? screen.selected
                                                : null,
                                        ].join(" ")}
                                        onClick={() => updateSize(index)}
                                    >
                                        {item.size}
                                    </button>
                                ))}
                            </div>

                            {/* Drag & Drop Upload Box */}
                            <div
                                className={`${screen.imageUploadView} ${isDragging ? screen.dragging : ""
                                    }`}
                                onClick={handleFileClick}
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                                onDrop={handleDrop}
                            >
                                <span className="material-symbols-outlined icon-size-l">
                                    perm_media
                                </span>
                                <br />
                                <p className={screen.title}>Drop Image or Browse Files</p>
                                <p>Support: png, jpg, jpeg only</p>

                                <Button
                                    text="Upload image"
                                    rounded={true}
                                    hoverEffect={true}
                                    spaceTop={30}
                                />

                                {isDragging && (
                                    <p className={[general.colorPrimary, general.mgT15px].join(" ")}>Drop files here</p>
                                )}
                            </div>

                            <input
                                type="file"
                                accept="image/png,image/jpeg"
                                multiple
                                ref={fileInputRef}
                                style={{ display: "none" }}
                                onChange={handleFileChange}
                            />

                            {/* Uploaded images with click-to-delete */}
                            <div className={screen.uploadedImagesView}>
                                {uploadedImages.map((img, index) => (
                                    <ImageLoader
                                        src={img.preview}
                                        className={screen.imageView}
                                        alt="uploaded-image"
                                        key={`image_${index}`}
                                        action={{ onClick: () => handleImageClick(index) }}
                                    />
                                ))}
                            </div>
                        </div>

                        <div className={screen.overview}>
                            <p className={screen.title}>Order details</p>
                            <br />

                            <p>Instruction</p>
                            <div
                                className={[
                                    general.inpBoxOutline,
                                    general.inputTextArea,
                                    general.mgT10px,
                                ].join(" ")}
                            >
                                <textarea
                                    placeholder="Add instruction for your order"
                                    autoComplete="off"
                                    value={values.instruction}
                                    onChange={(e) => updateInput(e.target.value)}
                                />
                            </div>

                            <br />
                            <div className={screen.listView}>
                                <p>Quantity</p>

                                <div className={general.quantityView}>
                                    {/* <button
                                        onClick={() =>
                                            values.quantity > 1
                                                ? updateQuantity(
                                                    values.quantity - 1
                                                )
                                                : null
                                        }
                                    >
                                        <span className="material-symbols-outlined">
                                            remove
                                        </span>
                                    </button> */}

                                    <p>{values.quantity}</p>

                                    {/* <button
                                        onClick={() =>
                                            values.quantity < 100
                                                ? updateQuantity(
                                                    values.quantity + 1
                                                )
                                                : null
                                        }
                                    >
                                        <span className="material-symbols-outlined">
                                            add
                                        </span>
                                    </button> */}
                                </div>
                            </div>

                            <br />
                            <div className={screen.listView}>
                                <p>Total amount</p>
                                <p className={screen.subTitle}>
                                    ₹{values.subTotal}
                                </p>
                            </div>

                            <br />
                            <br />
                            <Button
                                text="Add to cart"
                                rounded={true}
                                fullWidth={true}
                                hoverEffect={true}
                                action={{ onClick: addToBag }}
                            />

                            {getStorage("accountID") === "" && (
                                <p className={[general.colorPrimary, general.textAlignCenter, general.mgT10px].join(" ")}>Sign in required to add items to your cart.</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Customization;